/* cart-2026.js — Rebuy Smart Cart restyle 2026 (ENG-7579, now the default — A/B removed).
   Reimplements the Rebuy patching pattern from scratch (events + /cart.js + idempotency).
   Does NOT depend on the TryNow code (removed in ENG-7558/PR #175). */
(function () {
  'use strict';

  // ── Cart 2026 is the default (A/B test removed, ENG-7579) ──
  // body.cart-2026 is now emitted statically by theme.liquid on every page (no longer added by
  // GrowthBook's decide()), so the Rebuy Smart Cart flyout restyle always applies. This deferred
  // script runs after <body> is parsed, so the class is already present: kick off the first
  // fonts + patch pass right away. refresh() stays guarded on the class defensively and the Rebuy
  // listeners below are always attached.
  function kick() {
    loadFonts();
    refresh(); // patch a cart Rebuy may have already rendered before this ran
  }
  kick();

  // ── Fonts (dedup with nav/footer 2026) ──
  function loadFonts() {
    var href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,700;1,400;1,500&family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400&display=swap';
    if (document.querySelector('link[href*="Playfair+Display"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  // ── Helpers ──
  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  // ── Order summary ──
  // Injected into Rebuy's `above_subtotal` slot → sits below the promo, above Rebuy's own
  // "Subtotal (N items)" footer line. Idempotent: updates in place if it already exists.
  // Injects ONLY a "Bundle saving" row off cart.total_discount (ALL discounts: line + cart level),
  // and only when there's a discount; the plain Subtotal row was removed (Rebuy's footer is the sole
  // subtotal/total shown). The page mirrors this basis (main-cart-2026.liquid uses total_discount).
  // NOTE: no "Shipping" row here — real shipping is computed at checkout, not in the cart, so it
  // can't be calculated. The free-shipping progress bar was removed in ENG-8162; Rebuy's own
  // native bar stays hidden by CSS, so the drawer shows no shipping progress at all.
  function injectOrderSummary(flyout, cart) {
    var slot = flyout.querySelector('[data-app-target="above_subtotal"]');
    if (!slot) return;
    var node = slot.querySelector('.cart-2026-summary');
    // The plain "Subtotal" row was removed (ENG-7579): it duplicated Rebuy's native
    // "SUBTOTAL (N items)" footer line — production shows a single subtotal. We now only inject a
    // "Bundle saving" line, and only when there's an actual discount; with no discount we inject
    // nothing (and clear any stale node) so Rebuy's subtotal is the sole total shown.
    if (!(cart.total_discount > 0)) {
      if (node) node.remove();
      return;
    }
    if (!node) {
      node = document.createElement('div');
      node.className = 'cart-2026-summary';
      slot.appendChild(node);
    }
    node.innerHTML =
      '<div class="cart-2026-summary-row saving"><span class="label">Bundle saving</span><span class="val">−' + money(cart.total_discount) + '</span></div>';
  }

  // ── Promo collapsible (Phase 5 fix) ──
  // The mockup's promo is a collapsed "Add a promo code" toggle (+) that reveals the input on
  // click. Rebuy shows its promo form always-open, so we inject a toggle button at the top of the
  // discount container and hide Rebuy's form via CSS until .cart-2026-promo-open is set. Idempotent.
  function injectPromoToggle(flyout) {
    var container = flyout.querySelector('.rebuy-cart__flyout-discount-container');
    if (!container) return;
    // Match the mockup's promo input placeholder ("Enter code"); Rebuy's native default differs.
    // Set on every render (Rebuy may reset it) — cheap, idempotent guard avoids redundant writes.
    var input = container.querySelector('input');
    if (input && input.getAttribute('placeholder') !== 'Enter code') {
      input.setAttribute('placeholder', 'Enter code');
    }
    if (container.querySelector('.cart-2026-promo-toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cart-2026-promo-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>Add a promo code</span><span class="cart-2026-promo-plus" aria-hidden="true">+</span>';
    btn.addEventListener('click', function () {
      var open = container.classList.toggle('cart-2026-promo-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    container.insertBefore(btn, container.firstChild);
  }

  // ── Line-item controls (Remove placement) ──
  // Rebuy renders the remove control separately from the qty widget (and may use an icon, not text).
  // The mockup wants a "Remove" text link sitting right next to the qty stepper (mockup .item-controls:
  // qty + Remove in one inline row). For each line item we group the qty widget and the remove button
  // into a .cart-2026-controls flex row (qty first, then Remove) and force the label to "Remove".
  // Idempotent + re-homing: Rebuy re-renders wipe our row, so apply() rebuilds it on every event.
  function groupItemControls(flyout) {
    var items = flyout.querySelectorAll('.rebuy-cart__flyout-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var removeBtn = item.querySelector('.rebuy-cart__flyout-item-remove');
      var qty = item.querySelector('.rebuy-cart__flyout-item-quantity') ||
                item.querySelector('.rebuy-cart__flyout-item-quantity-widget');
      if (!removeBtn || !qty) continue;
      // Force the remove control to read "Remove" (Rebuy may render an icon or other copy).
      if (removeBtn.textContent.trim() !== 'Remove') removeBtn.textContent = 'Remove';
      var row = item.querySelector('.cart-2026-controls');
      if (!row) {
        row = document.createElement('div');
        row.className = 'cart-2026-controls';
        qty.parentNode.insertBefore(row, qty);
      }
      // Re-home qty + Remove into the row (covers first build and Rebuy re-renders).
      if (qty.parentNode !== row) row.appendChild(qty);
      if (removeBtn.parentNode !== row) row.appendChild(removeBtn);
    }
  }

  // ── Item title: split off the "n,XXX" fragrance code ──
  // Rebuy renders the whole title as one string with the code leading ("n,551 Amber Sunset Body
  // Butter"). The mockup wants the name first and the code last, in its own (Playfair) style. We
  // re-home the leading code into a trailing <span class="cart-2026-ncode">. Titles without a
  // leading code (e.g. "Noteworthy Fragrance-Free Priming Lotion") are left untouched. Idempotent:
  // the .cart-2026-ncode guard skips already-processed titles; Rebuy re-renders reset the text → reprocess.
  function styleTitleCode(flyout) {
    var titles = flyout.querySelectorAll('.rebuy-cart__flyout-item-product-title');
    for (var i = 0; i < titles.length; i++) {
      var a = titles[i];
      if (a.querySelector('.cart-2026-ncode')) continue;
      var m = (a.textContent || '').trim().match(/^(n,\d+)\s+(.+)$/i);
      if (!m) continue;
      a.textContent = '';
      a.appendChild(document.createTextNode(m[2]));
      var code = document.createElement('span');
      code.className = 'cart-2026-ncode';
      code.textContent = m[1];
      a.appendChild(code);
    }
  }

  // ── Re-apply hook: runs on every Rebuy render. Idempotent. ──
  function apply(cart) {
    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (!flyout || !cart) return;
    injectOrderSummary(flyout, cart);
    injectPromoToggle(flyout);
    groupItemControls(flyout);
    styleTitleCode(flyout);
  }

  // Coalescing guard: several events schedule overlapping refreshes (e.g. cart.add fires a fast
  // 400ms pass + a 1000ms safety net). Running them as overlapping fetches risks an out-of-order
  // resolve overwriting fresh state with stale, and double DOM mutations that can flicker. Instead
  // we run at most one /cart.js fetch at a time; a refresh requested while one is in flight is
  // collapsed into a single trailing pass that runs once the current one settles. This keeps the
  // intended behaviour (the early pass still runs immediately; the late pass still runs after Rebuy
  // finishes its async re-render) without overlap.
  var refreshing = false;
  var refreshPending = false;
  function refresh() {
    // Guard on the class on EVERY call (defensive; the Rebuy listeners below are attached
    // unconditionally).
    if (!document.body.classList.contains('cart-2026')) return;
    if (refreshing) { refreshPending = true; return; }
    refreshing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {})
      .then(function () {
        refreshing = false;
        if (refreshPending) { refreshPending = false; refresh(); }
      });
  }

  // Mirror of the Rebuy event set (reimplemented, without depending on TryNow).
  // smartcart.ready fires immediately; the line-item.* and show events need Rebuy
  // to finish re-rendering (~500ms); cart.add brings a different payload → we refresh
  // against /cart.js with a larger margin (~1000ms).
  document.addEventListener('rebuy:smartcart.ready', refresh);
  document.addEventListener('rebuy:smartcart.show', function () { setTimeout(refresh, 500); });
  document.addEventListener('rebuy:smartcart.line-item-increase', function () { setTimeout(refresh, 500); });
  document.addEventListener('rebuy:smartcart.line-item-decrease', function () { setTimeout(refresh, 500); });
  document.addEventListener('rebuy:smartcart.line-item-removed', function () { setTimeout(refresh, 500); });
  // cart.add: fire an early pass (~400ms) so the relabeled "Remove" shows up fast — the native
  // trash icon stays hidden via CSS until then — plus a late pass (~1000ms) as the safety net.
  document.addEventListener('rebuy:cart.add', function () {
    setTimeout(refresh, 400);
    setTimeout(refresh, 1000);
  });

  // Promo apply may not emit any rebuy:* event, so refresh the summary when the user applies a
  // discount in Rebuy's promo field — on click of Apply, or Enter inside the discount container.
  // Chosen over a broad MutationObserver on .rebuy-cart__flyout to avoid re-render loops (our own
  // injections mutate the flyout, which would re-trigger the observer). Two refreshes cover Rebuy's
  // async update.
  function onPromoApply(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.rebuy-cart__flyout-discount-container')) return;
    setTimeout(refresh, 800);
    setTimeout(refresh, 1600);
  }
  document.addEventListener('click', onPromoApply, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') onPromoApply(e); }, true);
})();
